<div class="row">
    <div class="col-sm-12 col-md-8 col-md-offset-2">

        <div class="column-testimonial">

            <!--The content will either be a Quill editor or a customer-site-column-text-->
            <ng-content select=".customer-site-column-testimonial-content"></ng-content>

        </div>
    </div>
</div>